/* =================== FAQ ACCORDION (VANILLA JS) =================== */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    const faqQuestions = document.querySelectorAll(".faq-question");
    if (faqQuestions.length === 0) return;

    faqQuestions.forEach((question) => {
      question.addEventListener("click", function () {
        const item = this.parentElement;
        const answer = item.querySelector(".faq-answer");
        const isActive = item.classList.contains("active");

        // Fecha todas as outras perguntas abertas
        const activeItems = document.querySelectorAll(".faq-item.active");
        activeItems.forEach((activeItem) => {
          if (activeItem !== item) {
            activeItem.classList.remove("active");
            const activeAnswer = activeItem.querySelector(".faq-answer");
            if (activeAnswer) {
              activeAnswer.style.maxHeight = "0px";
              activeAnswer.classList.remove("active");
            }
            const activeQuestion = activeItem.querySelector(".faq-question");
            if (activeQuestion) {
              activeQuestion.setAttribute("aria-expanded", "false");
            }
          }
        });

        // Alterna o estado atual
        if (!isActive) {
          item.classList.add("active");
          this.setAttribute("aria-expanded", "true");
          answer.classList.add("active");
          // Seta a altura exata do scroll do conteúdo para transicionar suavemente
          answer.style.maxHeight = answer.scrollHeight + "px";
        } else {
          item.classList.remove("active");
          this.setAttribute("aria-expanded", "false");
          answer.style.maxHeight = "0px";
          // Remove class ativa após transição
          setTimeout(() => {
            if (!item.classList.contains("active")) {
              answer.classList.remove("active");
            }
          }, 400);
        }
      });
    });

    // Ajusta a altura max-height em caso de resize da janela (responsivo)
    window.addEventListener("resize", function () {
      const activeAnswer = document.querySelector(".faq-item.active .faq-answer");
      if (activeAnswer) {
        activeAnswer.style.maxHeight = activeAnswer.scrollHeight + "px";
      }
    });
  });
})();
